import s from './BlogDetail1.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from 'react-helmet-async';

const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'ジェイさんブログ', link: '/blog' },
  { label: 'ジェイさんマガジン', link: '/blog/magazine' },
  { label: 'キュランダ観光ツアー ジェイさんツアーマガジン#01'}
];


const BlogDetail1 = () => {
  return (
    <>
          <Helmet>
        <title>キュランダ観光ツアー ジェイさんツアーマガジン#01</title>
        <meta property="og:title" content="キュランダ観光ツアー ジェイさんツアーマガジン#01" />
        <meta property="og:image" content="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_01_thum-1140x530.png" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/blog/magazine/num01`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>
    <div className={s.root}>
      <SubHeader
      title="キュランダ観光ツアー ジェイさんツアーマガジン#01"
      breadcrumbs={breadcrumbs}
    />
    <div className={s.flex}>
      <div className={s.width}>
      <div className={s.cardContent}>
        <h2 className={s.cardTitle}>キュランダ観光ツアー ジェイさんツアーマガジン#01</h2>
        <ul className={s.article}>
          <li>
            <i class="fa fa-calendar"></i><a href="https://dev.mightyaussie.com/blog/magazine/num01"><time itemprop="datePublished" class="entry-date published" datetime="2019-12-13T10:42:20+09:00">2019年12月13日</time></a>
          </li>
          <li><i class="fa fa-user"></i><span itemprop="author" itemscope="" itemtype="https://schema.org/Person" class="vcard author"><span class="fn" itemprop="name">ジェイさんツアー</span></span></li>
          <li><i class="fa fa-pencil"></i><span itemprop="articleSection"><a href="https://dev.mightyaussie.com/category/blog/magazine">ジェイさんマガジン</a></span></li>
        </ul>
      </div>
      <img
        src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_01_thum-1140x530.png"
        alt="キュランダ観光ツアー ジェイさんツアーマガジン#01"
        className={s.cardImage}
      />
      <h2>キュランダ観光ツアー</h2>
      <p>ケアンズの絶対外せない定番ツアー
      日本人が忘れかけている、ゆったり時間を取り戻す旅</p>
      <img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_02-819x1024.png" alt="" />
      <h2>キュランダ列車でめぐるレトロで贅沢な旅</h2>
      <p>キュランダ観光ツアーのコースによっては、朝にケアンズセントラルから出発しないものもございます
詳細はお問い合わせください。</p>
<p>キュランダ列車はケアンズセントラル液とキュランダ駅の２拠点からの出発があります。参加するツアーで出発地がかわりますが、どちらも同じコースを走ります。</p>
      <img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_03-825x1024.png" alt="" />
      <h2 class="blog_h2">約100分の列車に揺られる心地よい時間</h2>
      <p>座席は指定席ですが、動き出してしまえば移動しても問題ありません。途中で撮影スポットがありますので、カメラ撮影を忘れずに。<br/>
バロンフォールズの音とキュランダ列車のゆっくりすすむ車両の音が心地よい。</p>
      <img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_04.png" alt="" />
      <h2 class="blog_h2">有料オプションゴールドクラス、より贅沢で優雅な旅に。</h2>
      <p><span class="f_atte">※15:30発の列車のみ、ゴールドクラスにアップグレードが可能です。</span></p>
      <p>ゴールドクラスは一般車両と異なり、一人ひとりの専用座席仕様。更にワインやビール、軽食がついてくる素敵なオプションメニューとなっています。（列車代＋A49ドル）<br/>
このお値段でファーストクラス並みの雰囲気とサービスは特別感間違いありません！<br/>
<span class="f_atte">※2019年12月現在の価格です</span></p>
    <img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_05.png" alt="" />
    <h2 class="blog_h2">コアラの抱っこ写真は逃せない！</h2>
    <p>キュランダ観光では、レインフォレステーションとコアラガーデンズでコアラを見ることができます。<br/>
<span class="f_atte">※写真はレインフォレステーションでのコアラ抱っこ写真</span></p>
<h3>レインフォレステーション</h3>
<p>コアラ写真に関するオプションメニュー<br/>
2名までの撮影：A25ドル<br/>
3名以上の撮影：A37ドル<br/>
<span class="f_atte">※小学生未満もしくは身長が120cm未満の方は抱っこできません（一緒に撮影は可能）</span></p>
<p>キュランダデラックスコース、アーミーダックを選択している場合はこちらに立ち寄ります。</p>
<h3>コアラガーデンズ</h3>
<p>レインフォレステーションだと、水陸両用車アーミーダックに乗車できますよ！</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_06.png" alt="" />
<h2 class="blog_h2">キュランダの動植物園。熱帯雨林に囲まれた静かな楽園</h2>
<p>レインフォレステーションはキュランダ村から来るまで5分ほどの直ぐ側にある動植物園。ワラビーやカンガルーなど様々な動物との触れ合いや先住民アボリジニの文化体験、水陸両用車アーミーダックでめぐる熱帯雨林散策など、キュランダ観光名物がぎゅっと詰まったおすすめスポットです。</p>
<p>ケアンズへの滞在時間があまり長くない方や、たくさんのスポットへ出かけたい方にピッタリです。</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_07.png" alt="" />
<h2 class="blog_h2">世界最古の大森林、熱帯雨林を空から眺める</h2>
<p>1988年にユネスコより世界自然遺産に登録され、現存する熱帯雨林の中で最も古いといわれています。</p>
<p>キュランダ村にあるスカイレールの駅前は、建物と緑のコントラストが美しいため、多くの方が撮影されております。みんなも記念に１枚撮ろう！</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_08.png"/>
<h2 class="blog_h2">キュランダ村のおすすめは地元の人に聞く</h2>
<p>キュランダ村は小さな村です。<br/>
2時間もあれば、全て回れるくらいなほどに。</p>
<p>先住民アボリジニがキュランダに移住した歴史を知ることでキュランダの特産品や物の価値を改めて知ることができます。</p>
<p>小さな村でありながら知れば知るほど面白味が出てくる不思議な魅力が詰まったキュランダ村でのんびり過ごしてみてください。</p>
<img src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_09.png" alt="" />
<h2 class="blog_h2">独自に発展した、キュランダのクリエイティブな文化</h2>
<p>元々は人が住みづらい場所だったが、自分たちの生活を作るためにこの土地でモノづくりを始めた。手作りにこだわりを持ち、独特な趣を持った一品がここにある。</p>
<img className={s.follow} src="https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_10.png" alt="" />
<div className={s.tour}>
  <img src="	https://dev.mightyaussie.com/wp-content/uploads/2019/05/KURANDA_RAILWAY_med.jpg" alt="" />

  <div class="wpb_wrapper">
			<h3>その他のキュランダ列車やキュランダ観光ができるツアーはこちら</h3>
<p>このツアーの他にも、キュランダを観光できるツアーがたくさんあります。キュランダ列車やスカイレールといったキュランダ観光には欠かすことができないツアーからレインフォレステーションでのアーミーダックや動物園など、キュランダを観光できるツアーの一覧です。</p>
<div class="vc_btn3-container vc_btn3-left"><a className={s.link} href="/all-tours?kw=キュランダ" title="">キュランダ観光に関するツアー一覧を見る</a></div>
  </div>

</div>
</div>
<Aside/>
</div>
    </div>
    </>
  );
};

export default BlogDetail1;
